import React from "react";
import WeBridgeLogo from "../images/WeBridgeLogo.png";
import WeBridgeSite from "../images/WebridgePage.png";
import PuntAutoSiteImg from "../images/PuntPage.png";
import PuntautoLogo from "../images/PuntLogo.jpg";
const Related = () => {
  return (
    <>
      <h3 class="my-4">Related Projects</h3>

      <div class="row">
        <div class="col-md-3 col-sm-6 mb-4">
          <a href="#">
            <img
              class="img-fluid"
              src="https://via.placeholder.com/500x300"
              alt=""
            />
          </a>
        </div>

        <div class="col-md-3 col-sm-6 mb-4">
          <a href="#">
            <img
              class="img-fluid"
              src="https://via.placeholder.com/500x300"
              alt=""
            />
          </a>
        </div>

        <div class="col-md-3 col-sm-6 mb-4">
          <a href="#">
            <img
              class="img-fluid"
              src="https://via.placeholder.com/500x300"
              alt=""
            />
          </a>
        </div>

        <div class="col-md-3 col-sm-6 mb-4">
          <a href="#">
            <img
              class="img-fluid"
              src="https://via.placeholder.com/500x300"
              alt=""
            />
          </a>
        </div>
      </div>
    </>
  );
};
const Project = ({ children }) => {
  return (
    <div className="col-md-6 col-lg-4 mb-4">
      <div className="card h-100 shadow-sm">{children}</div>
    </div>
  );
};

const ProjectDetails = ({ children }) => {
  return <div className="row">{children}</div>;
};

export default function Projects() {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Projects</h2>

      <div className="row g-4">
        <Project>
          <a
            href="https://www.webridge.co.za/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="card-img-top"
              src={WeBridgeSite}
              alt="WeBridge"
              style={{ maxHeight: "400px", objectFit: "cover" }}
            />
          </a>
          <div className="card-body">
            <h5 className="card-title text-center">WeBridge</h5>
          </div>
        </Project>
        <Project>
          <a
            href="http://www.puntauto.co.za/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="card-img-top"
              src={PuntAutoSiteImg}
              alt="Punt Auto"
              style={{ maxHeight: "400px", objectFit: "cover" }}
            />
          </a>
          <div className="card-body">
            <h5 className="card-title text-center">Punt Auto</h5>
          </div>
        </Project>
      </div>
    </div>
  );
}
